import React from "react";
import { Grid, Card, CardHeader, CardContent } from "@mui/material";
import { RosterEmpty } from "../../Containers/Teams";
import { UserList } from "../User/List";
import { TeamSelector } from "./Selector";
import { Team, User } from "../../types";

interface TeamRosterProps {
  users?: User[];
  teams?: Team[];
  selectedUsers: string[];
  isLoading: boolean;
  onAssign: (userIds: string[], team: Team) => void;
  onSelect: (userId: string[]) => void;
}
export const TeamRoster = ({
  users = [],
  teams = [],
  isLoading = false,
  selectedUsers = [],
  onAssign,
  onSelect,
}: TeamRosterProps) => {
  let unassignedUsers = users || [];

  if (teams) {
    console.log({ teams });
    teams.forEach((team) => {
      unassignedUsers = unassignedUsers.filter(
        (user) => team.userIds.indexOf(user.id) < 0,
      );
    });
  }

  return (
    <Grid item xs={12} md={6} lg={6}>
      {isLoading || users === undefined ? (
        <>Loading users!</>
      ) : (
        <>
          {unassignedUsers && unassignedUsers.length > 0 && (
            <Card>
              <CardHeader
                title="Roster"
                action={
                  selectedUsers.length > 0 && (
                    <TeamSelector
                      teams={teams ? teams : []}
                      label="Assign team members"
                      onChange={(team) => onAssign(selectedUsers, team)}
                    />
                  )
                }
              />
              <CardContent>
                <UserList
                  users={unassignedUsers}
                  setSelected={onSelect}
                  selected={selectedUsers}
                />
              </CardContent>
            </Card>
          )}
          {unassignedUsers.length === 0 && <RosterEmpty />}
        </>
      )}
    </Grid>
  );
};
